import { render, staticRenderFns } from "./tabs-card.vue?vue&type=template&id=4ada2f7f&scoped=true"
import script from "./tabs-card.vue?vue&type=script&lang=js"
export * from "./tabs-card.vue?vue&type=script&lang=js"
import style0 from "./tabs-card.vue?vue&type=style&index=0&id=4ada2f7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada2f7f",
  null
  
)

export default component.exports